import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FeatherIcon } from "../ui/FeatherIcon";

const TextLinkClassName =
  "text-neutral-500 hover:text-neutral-700 hover:underline transition";

function AboutPanel({
  forceShow,
  showCanvasSelector,
  onClose,
}: {
  forceShow: boolean;
  showCanvasSelector: () => void;
  onClose: () => void;
}) {
  const [forceHide, setForceHide] = useState(false);
  useEffect(() => {
    if (forceHide) {
      const timeout = setTimeout(() => setForceHide(false), 10);
      return () => clearTimeout(timeout);
    }
  }, [forceHide]);
  const [lastBuildString] = useState(() => {
    const buildDate = new Date(VITE_APP_BUILD_TIME);
    return `${buildDate.getMonth() + 1}/${buildDate.getDate()}`;
  });
  const history = useHistory();
  return (
    <div
      className={classNames(
        "absolute top-10 md:top-12 md:pt-2 -right-4 md:-right-2 transition transform hover-hover:group-hover:opacity-100 hover-hover:group-hover:scale-100 hover-hover:group-hover:pointer-events-auto",
        {
          "pointer-events-none opacity-0 scale-90": !forceShow,
          hidden: forceHide,
        }
      )}
      style={{ transformOrigin: "top right" }}
    >
      <div className="bg-neutral-0 sm:rounded-lg w-[385px] max-w-[100vw] px-8 py-4 shadow-lg relative">
        <div className="natto-icon mx-auto mb-4 relative left-[30px]" />
        <div className="mb-4 text-center">
          <div className="text-secondary-700 font-mono-natto text-lg">
            natto.dev{" "}
            <span className="inline-block transform -scale-y-100">HACKED</span>
          </div>
          <div className="text-neutral-500">
            write{" "}
            <span className="line-through decoration-neutral-400">JavaScript</span>{" "}
            Python on a 2D canvas
          </div>
        </div>
        <div className="mb-4 text-neutral-300">
          <div>
            {"→ "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                showCanvasSelector();
              }}
              className={TextLinkClassName}
            >
              examples
            </a>
          </div>
          <div>
            {"→ "}
            <button
              onClick={() => {
                history.push("/tutorial/tip-calculator");
                setForceHide(true);
                onClose();
              }}
              className={TextLinkClassName}
            >
              interactive tutorial
            </button>
          </div>
          <div>
            {"→ "}
            <a
              href="https://www.notion.so/paulshen/Documentation-44fea11f393a4e46b5a22f5799de58ca"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              documentation
            </a>
          </div>
          <div>
            {"→ "}
            <a
              href="https://www.notion.so/paulshen/Changelog-9fd553d862244750a8ee0c679956afd2"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              changelog
            </a>
            <span className="text-neutral-400 ml-1">
              (code update {lastBuildString})
            </span>
          </div>
          <div>
            {"→ "}
            <a
              href="https://discord.com/invite/2GGMn7fTKQ"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              discord
            </a>
          </div>
        </div>
        <div className="mb-4">
          You are looking at a stripped-down version of the JavaScript-centric{" "}
          <a
            href="https://natto.dev"
            target="_blank"
            rel="noreferer"
            className="underline"
          >
            natto.dev
          </a>
          . Please check that out!
        </div>
        <div className="mb-4">
          Follow updates and send feedback{" "}
          <a
            href="https://twitter.com/_paulshen"
            target="_blank"
            rel="noreferrer"
            className="text-primary-500 underline"
          >
            @_paulshen
          </a>
        </div>
        {forceShow ? (
          <button
            onClick={() => {
              setForceHide(true);
              onClose();
            }}
            className="flex p-1 absolute top-1 right-1 text-neutral-400 hover:text-neutral-700"
          >
            <FeatherIcon icon="x" size="md" />
          </button>
        ) : null}
      </div>
    </div>
  );
}

export function AboutButton({
  isOnWelcomeCanvas,
  showCanvasSelector,
}: {
  isOnWelcomeCanvas: boolean;
  showCanvasSelector: () => void;
}) {
  const [showAbout, setShowAbout] = useState(false);
  // useEffect(() => {
  //   if (!showAbout) {
  //     localStorage.setItem("dismiss_about", "true");
  //   }
  // }, [showAbout]);
  return (
    <div className="group relative h-full">
      <button
        onClick={() => setShowAbout((v) => !v)}
        className="text-neutral-600 h-full px-2"
      >
        about
      </button>
      <AboutPanel
        forceShow={showAbout}
        showCanvasSelector={showCanvasSelector}
        onClose={() => setShowAbout(false)}
      />
    </div>
  );
}
